import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = {
  key: 0,
  class: "col-12"
}
const _hoisted_3 = { class: "row q-col-gutter-md" }
const _hoisted_4 = {
  key: 1,
  class: "relative-position col-12",
  style: {"height":"200px"}
}
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = {
  key: 0,
  class: "flex justify-center q-my-lg"
}

import MarketplaceApi from 'src/api/market';
import {ref} from 'vue';
import {CustomPagination} from 'src/models/qutils/etc'
import ItemCard from 'src/apps/market/components/ItemCard.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileItemList',
  props: {
  userUuid: {
    required: true,
    type: String,
  },
  count: {
    type: Number,
    default: 0,
  }

},
  emits: ['update:count'],
  setup(__props, { emit: __emit }) {

const props = __props
const itemsResponse = ref<CustomPagination>()
const loading = ref(true)
const currentPage = ref(1)
const emit = __emit

const getPage = function (page) {
  itemsResponse.value = undefined
  MarketplaceApi.fetchItems({by_user: props.userUuid, is_business: false, page}).then(resp => {
    itemsResponse.value = resp.data
    currentPage.value = page
    emit('update:count', itemsResponse.value?.count)
  }).catch(err => {
    console.error(err)
  }).finally(() => {
    loading.value = false
  })
}
getPage(1)


return (_ctx: any,_cache: any) => {
  const _component_q_pagination = _resolveComponent("q-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    (itemsResponse.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (itemsResponse.value?.results?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsResponse.value.results, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.uuid,
                      class: "col-6 col-sm-4 col-md-3"
                    }, [
                      _createVNode(ItemCard, { "model-value": item }, null, 8, ["model-value"])
                    ]))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[1] || (_cache[1] = [
                _createElementVNode("div", { class: "absolute-center" }, "Keine Flohmarkt Anzeigen bisher", -1)
              ]))),
          _createElementVNode("div", _hoisted_5, [
            (itemsResponse.value.pages > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_q_pagination, {
                    disable: loading.value,
                    max: itemsResponse.value.pages,
                    "model-value": currentPage.value,
                    "direction-links": "",
                    flat: "",
                    unelevated: "",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = val => getPage(val))
                  }, null, 8, ["disable", "max", "model-value"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})